module.exports = __webpack_public_path__ + "img/software_icon1.8b55ed3f.png";